module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ISO_IEC 27001-2013.df0974df.png";